module.exports = __webpack_public_path__ + "static/img/mapBg.4bcf939.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mapBg.svg
// module id = jWoq
// module chunks = 1